import { DEFAULTAPPUS } from '@myspot_org/ngx-core';
import { WhiteLabelConfig, WhiteLabelRegistry } from '@myspot_org/ngx-core/models';
import { WhiteLabelService } from '@myspot_org/ngx-services';
import { environment } from '../environments/environment';

export const env = environment.config;
const defaultHosts = [
  { hostname: 'localhost', port: '4200' },
  { hostname: 'room-panel.myspothub.com' },
  { hostname: 'myspot-crestron-ngx-dev.myspotdev.com' },
  { hostname: 'myspot-crestron-ngx-stg.myspotdev.com/' },
];

const defaultIconsPath = '/assets/icons';

export const whiteLabelRegistry: WhiteLabelRegistry = {
  ADR: {
    hasCustomUrl: false,
    isTenantRelated: true,
    alternateName: 'adr',
    tenantCodes: ['ADR'],
    code: 'ADR_COWO',
    colorTheme: 'theme-adr',
    showPoweredByLogo: false,
    poweredByLogo: '',
    iconsPath: defaultIconsPath,
    hosts: defaultHosts,
    logo: {
      logo: '/assets/images/logos/ADR-negative.svg',
      logoMobile: '/assets/images/logos/ADR-negative.svg',
      isDefault: false,
      link: '/',
      logoAlt: 'Logo ADR',
    },
  },
  ADR_OPEN: {
    hasCustomUrl: false,
    isTenantRelated: true,
    alternateName: 'adr_open',
    tenantCodes: ['ADR_OPEN'],
    code: 'ADR_COWO',
    colorTheme: 'theme-adr',
    showPoweredByLogo: false,
    poweredByLogo: '',
    iconsPath: defaultIconsPath,
    hosts: defaultHosts,
    logo: {
      logo: '/assets/images/logos/ADR_OPEN-negative.svg',
      logoMobile: '/assets/images/logos/ADR_OPEN-negative.svg',
      isDefault: false,
      link: '/',
      logoAlt: 'Logo ADR',
    },
  },
  BIP: {
    hasCustomUrl: false,
    isTenantRelated: true,
    alternateName: 'bip',
    tenantCodes: ['BIP'],
    code: 'BIP',
    colorTheme: 'theme-bip',
    showPoweredByLogo: false,
    poweredByLogo: '',
    iconsPath: defaultIconsPath,
    hosts: defaultHosts,
    logo: {
      logo: '/assets/images/logos/BIP-negative.svg',
      logoMobile: '/assets/images/logos/BIP-negative.svg',
      isDefault: false,
      link: '/',
      logoAlt: 'Logo BIP',
    },
  },
  POLIMI: {
    hasCustomUrl: false,
    isTenantRelated: true,
    alternateName: 'polimi',
    tenantCodes: ['POLIMI'],
    code: 'POLIMI',
    colorTheme: 'theme-polimi',
    showPoweredByLogo: false,
    poweredByLogo: '',
    iconsPath: defaultIconsPath,
    hosts: defaultHosts,
    logo: {
      logo: '/assets/images/logos/Polimi-negative.svg',
      logoMobile: '/assets/images/logos/Polimi-negative.svg',
      isDefault: false,
      link: '/',
      logoAlt: 'Logo Polimi',
    },
  },
  BIOTRONIK: {
    hasCustomUrl: false,
    isTenantRelated: true,
    alternateName: 'biotronik',
    tenantCodes: ['BIOTRONIK'],
    code: 'BIOTRONIK',
    colorTheme: 'theme-biotronik',
    showPoweredByLogo: true,
    poweredByLogo: 'assets/images/logos/powered-by_myspot.svg',
    iconsPath: defaultIconsPath,
    hosts: defaultHosts,
    logo: {
      logo: '/assets/images/logos/Biotronik-negative.svg',
      logoMobile: '/assets/images/logos/Biotronik-negative.svg',
      isDefault: false,
      link: '/',
      logoAlt: 'Logo Biotronik',
    },
  },
  ERIDANIA: {
    hasCustomUrl: false,
    isTenantRelated: true,
    alternateName: 'eridania',
    tenantCodes: ['ERIDANIA'],
    code: 'ERIDANIA',
    colorTheme: 'theme-eridania',
    showPoweredByLogo: false,
    poweredByLogo: '',
    iconsPath: defaultIconsPath,
    hosts: defaultHosts,
    logo: {
      logo: '/assets/images/logos/Eridania-negative.svg',
      logoMobile: '/assets/images/logos/Eridania-negative.svg',
      isDefault: false,
      link: '/',
      logoAlt: 'Logo Eridania',
    },
  },
  IFI: {
    hasCustomUrl: false,
    isTenantRelated: true,
    alternateName: 'ifi',
    tenantCodes: ['IFI'],
    code: 'IFI',
    colorTheme: 'theme-ifi',
    showPoweredByLogo: false,
    poweredByLogo: '',
    iconsPath: defaultIconsPath,
    hosts: defaultHosts,
    logo: {
      logo: '/assets/images/logos/IFI-negative.svg',
      logoMobile: '/assets/images/logos/IFI-negative.svg',
      isDefault: false,
      link: '/',
      logoAlt: 'Logo IFI',
    },
  },
  CA_VITA: {
    hasCustomUrl: false,
    isTenantRelated: true,
    alternateName: 'ca_vita',
    tenantCodes: ['CA_VITA'],
    code: 'CA_VITA',
    colorTheme: 'theme-cavita',
    showPoweredByLogo: false,
    poweredByLogo: '',
    iconsPath: defaultIconsPath,
    hosts: defaultHosts,
    logo: {
      logo: '/assets/images/logos/CA_VITA-negative.svg',
      logoMobile: '/assets/images/logos/CA_VITA-negative.svg',
      isDefault: false,
      link: '/',
      logoAlt: 'Logo CA Vita',
    },
  },
};

const MYSPOT_COWO = 'MYSPOT_COWO';
const MYSPOT_US_COWO = 'MYSPOT_US_COWO';

const codes = WhiteLabelService.buildHostCodes(whiteLabelRegistry);

export const whiteLabelConfig: WhiteLabelConfig = {
  env,
  hostNamePortal: {
    default: MYSPOT_COWO,
    codes: {
      ...codes,
      [MYSPOT_US_COWO]: [{ hostname: 'localhost', port: '4203' }, { hostname: DEFAULTAPPUS }],
    },
  },
  origin: {
    default: '',
    codes: {
      'myspot-frontend-dev.myspotdev.com': [{ hostname: 'localhost', env: 'dev', port: '4200' }],
      'myspot-frontend-stg.myspotdev.com': [{ hostname: 'localhost', env: 'stg', port: '4200' }],
      'app.myspothub.com': [{ hostname: 'localhost', env: 'prod', port: '4200' }],
      ...WhiteLabelService.buildOriginCodesFromRegistry(whiteLabelRegistry), // WL: crea i vari match con gli hostname presenti nelle white label del registry
    },
  },
  registry: whiteLabelRegistry,
};

console.log('White label config done');
